@if (visible) {
  <mat-form-field appearance="outline" [ngClass]="['col-12 col-sm-12 col-md-8 col-lg-8 col-xl-5',cssClassName]">
    <input matInput [(ngModel)]="searchTerm" id="searchText" autocomplete="off" placeholder="{{label}}"
      [className]="cssClassName"
      [ngModelOptions]="{standalone: true}" (keyup.enter)="searchClick()"/>
    <a href="javascript:void(0)" matSuffix class="search-icon" i18n-title="@@search.title"
       title="Search" (click)="searchClick()">
      <mat-icon>search</mat-icon>
    </a>
  </mat-form-field>
  @if (showFilterButton) {
    <pub-filter-button></pub-filter-button>
  }
}
